import request from '@/http/request'
export const getNddcBindReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/rfid/bind/report`, params)
}

export const getNddcBindSummary = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/rfid/bind/report/summary`, params)
}
export const exportNddcBindReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/rfid/bind/report/download`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
export const getNddcBindHistoryReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/rfid/bind/history`, params)
}

export const getNddcBindHistorySummary = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/rfid/bind/history/summary`, params)
}
export const exportNddcBindHistoryReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/rfid/bind/history/download`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
